import { Map } from 'immutable';
import defaultsDeep from 'lodash/defaultsDeep';

import { parsePageTree } from '../pages/reducer.pages';
import {
  ELEMENTS__ADD_UPLOAD,
  ELEMENTS__CREATE,
  ELEMENTS__DELETE,
  ELEMENTS__FETCH,
  ELEMENTS__PATCH,
  ELEMENTS__REPLACE,
  ELEMENTS__REVOKE_UPLOAD,
  ELEMENTS__SEND_UPLOAD,
  ELEMENTS__UPDATE,
  ELEMENT_TYPE__CHECKBOX_INPUT,
  ELEMENT_TYPE__RADIO_INPUT,
  ELEMENT_TYPE__TAROT_INPUT,
  PAGES__COPY,
  PAGES__CREATE,
  PAGES__DELETE,
  SURVEYS__FETCH_ACTIVE,
  SURVEY_EDITOR__RESET,
  USER__LOG_OFF,
} from '../constants';

import { findTags } from '../../blocks/dynamic-text';
import { mergeArray } from '../../util';

export const getDefaultState = () => new Map();

const confugure = (element, pageId) => {
  const tags = findTags(JSON.stringify(element));
  const result = {
    ...element,
    pageId,
    tags,
  };
  switch (element.type) {
    case ELEMENT_TYPE__CHECKBOX_INPUT:
    case ELEMENT_TYPE__RADIO_INPUT:
      return defaultsDeep(element, {
        properties: {
          defaultValue: null,
        },
      });
    case ELEMENT_TYPE__TAROT_INPUT:
      return {
        ...result,
        properties: {
          ...result.properties,
          values: mergeArray(new Map(), result.properties.values),
        },
      };
    default:
      return result;
  }
};

function parseResponse(state, data) {
  return data.reduce((newState, page) => {
    const { elements } = parsePageTree(page);
    const rows = elements.reduce(
      (acc, element) => acc.merge({ [element.id]: confugure(element, page.id) }),
      newState,
    );
    return rows;
  }, state);
}

function patch(state, action) {
  const { id: elementId } = action.element;
  return state.mergeIn([elementId], action.newProps).mergeIn([elementId], { patched: Date.now() });
}

function revokeUpload(state, { id }) {
  const preview = state.getIn([id, 'upload', 'preview']);
  if (preview) window.URL.revokeObjectURL(preview);
  return state.deleteIn([id, 'upload']);
}

export default function (state = getDefaultState(), action) {
  switch (action.type) {
    case ELEMENTS__ADD_UPLOAD:
      return revokeUpload(state, action.element).setIn(
        [action.element.id, 'upload'],
        action.upload,
      );
    case ELEMENTS__REVOKE_UPLOAD:
    case ELEMENTS__SEND_UPLOAD:
      return revokeUpload(state, action.element);
    case ELEMENTS__CREATE:
    case ELEMENTS__FETCH:
    case ELEMENTS__UPDATE:
    case PAGES__CREATE:
      return parseResponse(state, action.data);
    case PAGES__COPY:
      return parseResponse(getDefaultState(), action.data);
    case ELEMENTS__PATCH:
      return patch(state, action);
    case ELEMENTS__REPLACE:
      return state.merge({ [action.element.id]: action.element });
    case PAGES__DELETE:
      return parseResponse(getDefaultState(), action.data);
    case ELEMENTS__DELETE:
      return state.delete(action.elementId);

    case SURVEY_EDITOR__RESET:
    case USER__LOG_OFF:
      return getDefaultState();
    case SURVEYS__FETCH_ACTIVE:
      return parseResponse(state, action.data.elements);
    default:
      return state;
  }
}
